<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
}
body {
  margin: 0px;
}
*{
	margin: 0;
	padding: 0;
}
a {
  text-decoration: none;
}
a:link {
  color: #9f9f9f;
}
a:visited {
  color: #9f9f9f;
}
a:hover {
  color: #9f9f9f;
}
a:active {
  color: #9f9f9f;
}
input:focus{
  outline: none;
}
.clear{
	clear: both;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #F4F4F4;
}
</style>
